import * as React from 'react';
import { Input, Select, DatePicker } from 'antd';
import { MetadataWithValues } from './ChangeMetadata';

export interface MetadataEditInputProps {
  value?: string;
  record: MetadataWithValues;
  onChange?: (val: string) => void;
}

export const MetadataEditInput = class extends React.Component<MetadataEditInputProps> {
  handleChange = (newValue: string) => {
    this.props.onChange(newValue);
  }

  handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.handleChange(e.target.value);
  }

  render() {
    const { value, record = {} } = this.props;
    switch (record.format) {
      case '*':
      case '{USERFIRMA}':
      case '{USERNAME}':
      case '{USERID}':
      case String(record.format.match(/^{.*}$/)): // {'Any string'}
        return (
          <Input onChange={this.handleInputChange} value={value} />
        );
      case 'DATE':
      case '{DATE}':
        return (
          <DatePicker format="DD.MM.YYYY" onChange={val => this.handleChange(val.format('DD.MM.YYYY'))} />
        );
      case 'w':
      case 'W':
        return (
          <Select onChange={this.handleChange} style={{ width: '100%' }}>
            {record.rangeList?.map(item => (
              <Select.Option key={item.value} value={item.value}>{item.value} [{item.description}]</Select.Option>
            ))}
          </Select>
        );
      default:
        return <>{value}</>;
    }
  }

}